// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"303f9296","72":"9c40b5ad","127":"303f9296","447":"303f9296","565":"303f9296","959":"4be59da2"}[chunkId] + ".chunk.css";
};